import { apiService } from './api';

export type ExpenseCategory = 'mechanical' | 'cosmetics' | 'maintenance' | 'other';

export interface VehicleExpense {
  id: string;
  vehicle_id: string;
  tenant_id: string;
  category: ExpenseCategory;
  subcategory: string | null;
  amount: string;
  expense_date: string;
  notes: string | null;
  created_by: string;
  created_at: string;
  updated_at: string;
}

export interface CreateExpensePayload {
  category: ExpenseCategory;
  subcategory?: string;
  amount: string;
  expense_date: string;
  notes?: string;
}

export interface UpdateExpensePayload {
  category?: ExpenseCategory;
  subcategory?: string;
  amount?: string;
  expense_date?: string;
  notes?: string;
}

export type Period = 'week' | 'month' | 'ytd' | 'year_end' | 'custom';

export interface VehicleSummaryRow {
  id: string;
  year: number | null;
  make: string | null;
  model: string | null;
  vin: string | null;
  purchase: string;
  recon_period: string;
  recon_total: string;
  listing: string;
  margin: string;
  days_on_lot: number | null;
}

export interface InventoryCostsSummary {
  period: Period;
  period_start: string;
  period_end: string;
  spent_period: string;
  spent_ytd: string;
  avg_recon_per_vehicle: string;
  total_cost_basis: string;
  vehicles: VehicleSummaryRow[];
  spent_by_category: Record<'mechanical' | 'cosmetics' | 'maintenance' | 'other', string>;
  spent_by_month: Array<{ month: string; amount: string }>;
}

export const inventoryCostsApi = {
  createExpense: (vehicleId: string, payload: CreateExpensePayload) =>
    apiService.post<VehicleExpense>(`/vehicles/${vehicleId}/expenses`, payload),

  listExpenses: (vehicleId: string) =>
    apiService.get<VehicleExpense[]>(`/vehicles/${vehicleId}/expenses`),

  updateExpense: (expenseId: string, payload: UpdateExpensePayload) =>
    apiService.put<VehicleExpense>(`/expenses/${expenseId}`, payload),

  deleteExpense: (expenseId: string) => apiService.delete<void>(`/expenses/${expenseId}`),

  getSummary: (period: Period, start?: string, end?: string) => {
    const params = new URLSearchParams({ period });
    if (start) params.set('start', start);
    if (end) params.set('end', end);
    return apiService.get<InventoryCostsSummary>(`/inventory-costs/summary?${params.toString()}`);
  },
};
